import { render, staticRenderFns } from "./new_setup.vue?vue&type=template&id=6dd1c74e&scoped=true&"
import script from "./new_setup.vue?vue&type=script&lang=js&"
export * from "./new_setup.vue?vue&type=script&lang=js&"
import style0 from "./new_setup.vue?vue&type=style&index=0&id=6dd1c74e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd1c74e",
  null
  
)

export default component.exports